/**
 * RouteView component.
 * @module components/View/RouteView
 */
import { BodyClass, hasBlocksData } from '@plone/volto/helpers';
import { FormattedMessage } from 'react-intl';
import { Grid, Label } from 'semantic-ui-react';
import { UniversalLink, Image } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { isEmpty, map } from 'lodash';


const RouteView = (props) => {
  const { content } = props;

  return (
    <>
      <BodyClass className='route-view smallHeader' />
      <div className='routetItem'>
        <Grid className='mt-4'>
          <Grid.Row columns={12} className='align-items-start'>
            {content.preview_image && (
              <Grid.Column mobile={12} tablet={12} computer={7} widescreen={8} largeScreen={8}>
                <figure className='routeItem__figure'>

                  <Image className="routeItem__figure__img d-block"
                    alt=""
                    item={content}
                    imageField="preview_image"
                    responsive={true}
                    sizes="(max-width: 991px) 100vw, 25vw"
                  />
                  {content.preview_caption && (
                    <figcaption className='routeItem__figure__caption'>{content.preview_caption}</figcaption>
                  )}

                </figure>
                {/* Volto Blocks */}
                {hasBlocksData(content) ? (
                  <div className="userBlocks">
                    <RenderBlocks {...props} />
                  </div>
                ) : null}
              </Grid.Column>
            )}
            <Grid.Column className='flex-grow-1' mobile={12} tablet={12} computer={5} widescreen={4} largeScreen={4}>
              <dl className="routeItem__details mb-0 mt-5 mt-lg-0">

                {content?.track_gps &&
                  <div className="routeItem__concept">
                    <dt className="routeItem__concept__name">
                      <FormattedMessage id="Track GPS" defaultMessage="Track GPS" />
                    </dt>
                    <dd className="routeItem__concept__desc ms-0">
                      <a href={flattenToAppURL(content['@id'] + '/@@download/track_gps')}>
                        {content.track_gps.filename}
                      </a>
                    </dd>
                  </div>
                }

                {content?.map_url &&
                  <div className="routeItem__concept">
                    <dt className="routeItem__concept__name"><FormattedMessage id="Map URL" defaultMessage="Map URL" /></dt>
                    <dd className="routeItem__concept__desc ms-0"><a href={content.map_url}>{content.map_url}</a></dd>
                  </div>
                }

              </dl>
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </div>
    </>
  );
};

export default RouteView;